import { h } from 'preact';
import { Text } from 'preact-i18n';

/**
 * Build a lookup { [drugId]: product } from the clinic's products that are
 * linked to a drug (product.drug > 0). Soft-deleted products are skipped.
 * Returns a fresh object; nothing shared is touched.
 */
export function buildDrugProductMap(products) {
    const map = {};
    if (!Array.isArray(products)) {
        return map;
    }
    products.forEach((product) => {
        if (!product || !(product.drug > 0) || product.offline === 1) {
            return;
        }
        if (!map[product.drug]) {
            map[product.drug] = product;
        }
    });
    return map;
}

/**
 * Load the clinic's drug-linked products once (does not touch the store's
 * observable list) and return the lookup built by buildDrugProductMap.
 */
export async function loadDrugProductMap(productStore) {
    try {
        const products = await productStore.load({
            query: { hasDrug: 1 },
            limit: 1000,
            skipUpdate: true,
        });
        return buildDrugProductMap(products);
    } catch (error) {
        console.error('Failed to load drug-linked products:', error);
        return {};
    }
}

export default function DrugProductLinkBadge({ product, class: className = '' }) {
    if (!product) {
        return null;
    }
    return (
        <span
            class={`badge bg-success-subtle text-success-emphasis ${className}`}
            style='font-size: 0.7em; white-space: nowrap;'
            title={product.name}
        >
            <i class='fa-solid fa-pills me-1' />
            <Text id='dyrejournal.drug.linked-product'>Product</Text>: {product.name}
        </span>
    );
}
